/**
 * Darkens a hex color by a specified amount.
 * @param {string} color - Hex color (e.g., "#ffffff", "#fff", "#1976d2").
 * @param {number} amount - Darkening factor (0 to 1, e.g., 0.1 for 10%).
 * @returns {string} Darkened hex color (e.g., "#e6e6e6").
 */
export const darkenColor = (color, amount) => {
  // Validate hex color
  if (!/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color)) {
    console.warn(`Invalid hex color: ${color}. Returning original color.`);
    return color;
  }

  let hex = color.replace("#", "");
  // Expand short hex (e.g., #fff to #ffffff)
  if (hex.length === 3) {
    hex = hex.replace(/(.)/g, "$1$1");
  }

  // Parse RGB values
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  // Darken by reducing each channel
  const newR = Math.max(0, Math.round(r * (1 - amount)));
  const newG = Math.max(0, Math.round(g * (1 - amount)));
  const newB = Math.max(0, Math.round(b * (1 - amount)));

  // Convert back to hex
  return `#${newR.toString(16).padStart(2, "0")}${newG.toString(16).padStart(2, "0")}${newB.toString(16).padStart(2, "0")}`;
};
